import { configureStore } from "@reduxjs/toolkit";
import * as pdfDetectedFieldSlice from "../reducers/pdf-detected-fields/slice";
import * as pdfViewerSlice from "../reducers/pdf-viewer/slice";
import * as projectSlice from "../reducers/project/slice";
import * as editorSlice from "../reducers/editor/slice";
import * as appSlice from "../reducers/app/slice";

export const store = configureStore({
  reducer: {
    pdf: pdfViewerSlice.reducer,
    editor: editorSlice.reducer,
    project: projectSlice.reducer,
    pdfDetectedField: pdfDetectedFieldSlice.reducer,
    app: appSlice.reducer,
  },
});
